import type { App } from 'vue';
import { vSafeMarkdown } from './utils/santize-html';

export { sanitizeMarkdownHtml } from './utils/santize-html';

export const SafeHtmlPlugin = {
  install(app: App) {
    app.directive('safe-html', vSafeMarkdown);
  },
};
